<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <question-text
        v-model="form.question"
        :label="questionLabel"
        :disabled="isEditable"
        :requiredMessage="questionReq"
        :id="`question-${form.id}`"
      ></question-text>
    </v-col>
    <v-col cols="12" sm="12" md="12" v-if="form.isSubtitle">
      <question-text
        class="subtitle-1"
        :label="subtitleLabel"
        v-model="form.subtitle"
        :disabled="isEditable"
        :isSubtitle="form.isSubtitle"
        :id="`question-subtitle-${form.id}`"
      ></question-text>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <option-form
        v-model="form.options"
        :label="lblDefaultOption"
        :disabled="isEditable"
        :questionId="form.id"
      ></option-form>
    </v-col>
    <question-settings
      v-model="question"
      v-if="!isEditable"
    ></question-settings>
  </v-row>
</template>

<script>
import OptionForm from "../OptionForm.vue";
import MultipleSwitch from "./MultipleSwitch.vue";
import QuestionText from "./QuestionText.vue";
import QuestionSettings from "./QuestionSettings.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: { QuestionText, OptionForm, MultipleSwitch, QuestionSettings },
  name: "Choice",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    surveyType: {
      type: String,
      default: "survey",
    },
    responseQuestion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      question: this.value,
    };
  },
  computed: {
    ...mapState({
      surveyDetails: (state) => state.poll.surveyDetails,
    }),
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
    questionReq() {
      return this.$t("msgQuestionRequired");
    },
    subtitleReq() {
      return this.$t("msgSubtitleRequired");
    },
    questionLabel() {
      if (this.surveyType === "poll") {
        return this.$t("poll.lblPollQuestion");
      }
      return "";
    },
    mandatoryLabel() {
      return this.$t("poll.lblMandatoryResponse");
    },
    multipleAnswerLabel() {
      return this.$t("poll.lblMultipleAnswer");
    },
    lblDefaultOption() {
      return this.$t("poll.lblOption");
    },
    subtitleLabel() {
      return this.$t("poll.lblSubtitle");
    },
    form: {
      get() {
        return this.question;
      },
      set(value) {
        this.question = value;
        this.$emit("input", value);
      },
    },
    questionNumber() {
      return `${this.form.number}. `;
    },
    isEditable() {
      if (this.isSurveyExpired) {
        return true;
      }
      return this.responseQuestion.some(
        (item) => item.questionId === this.question.id
      );
    },
  },
};
</script>